import React from "react";
import { Link } from "react-router-dom";
import { BRAND, SOLUTIONS, USE_CASES } from "@/data/content";

export const Footer = ({ onOpenDemo }) => {
    return (
        <footer className="relative bg-warm border-t border-slate-200" data-testid="site-footer">
            <div className="container-x py-20 grid grid-cols-2 md:grid-cols-5 gap-10">
                <div className="col-span-2 md:col-span-2">
                    <img
                        src={BRAND.logo}
                        alt="NyraAI"
                        className="logo-mark h-14 w-auto mb-6"
                        style={{ transform: "scale(2.2)", transformOrigin: "left center" }}
                    />
                    <p className="text-slate-600 text-sm leading-relaxed max-w-sm">{BRAND.tagline}</p>
                    <button
                        onClick={onOpenDemo}
                        className="pill-dark mt-6"
                        data-testid="footer-book-demo"
                        style={{ padding: "12px 22px", fontSize: 13 }}
                    >
                        Book a demo
                    </button>

                    <div className="mt-10 space-y-3 text-sm">
                        <a
                            href={`tel:${BRAND.phone.replace(/[^+\d]/g, "")}`}
                            className="flex items-center gap-3 text-slate-700 hover:text-slate-900 transition-colors"
                            data-testid="footer-phone"
                        >
                            <i className="fa-solid fa-phone text-slate-500 w-4" />
                            {BRAND.phone}
                        </a>
                        <a
                            href={`mailto:${BRAND.emailSupport}`}
                            className="flex items-center gap-3 text-slate-700 hover:text-slate-900 transition-colors"
                            data-testid="footer-email"
                        >
                            <i className="fa-solid fa-envelope text-slate-500 w-4" />
                            {BRAND.emailSupport}
                        </a>
                    </div>
                </div>

                <div>
                    <div className="text-xs uppercase tracking-[0.2em] text-slate-500 mb-4">Solutions</div>
                    <ul className="space-y-2.5 text-sm">
                        {SOLUTIONS.map((s) => (
                            <li key={s.slug}>
                                <Link
                                    to={`/solutions/${s.slug}`}
                                    className="text-slate-700 hover:text-slate-900 transition-colors"
                                >
                                    {s.title}
                                </Link>
                            </li>
                        ))}
                    </ul>
                </div>

                <div>
                    <div className="text-xs uppercase tracking-[0.2em] text-slate-500 mb-4">Use Cases</div>
                    <ul className="space-y-2.5 text-sm">
                        {USE_CASES.map((u) => (
                            <li key={u.key}>
                                <Link
                                    to={`/use-cases#${u.key}`}
                                    className="text-slate-700 hover:text-slate-900 transition-colors"
                                >
                                    {u.name}
                                </Link>
                            </li>
                        ))}
                    </ul>
                </div>

                <div>
                    <div className="text-xs uppercase tracking-[0.2em] text-slate-500 mb-4">Company</div>
                    <ul className="space-y-2.5 text-sm">
                        <li>
                            <Link to="/" className="text-slate-700 hover:text-slate-900 transition-colors">
                                Home
                            </Link>
                        </li>
                        <li>
                            <Link to="/contact" className="text-slate-700 hover:text-slate-900 transition-colors">
                                Contact Us
                            </Link>
                        </li>
                        <li>
                            <Link to="/trust" className="text-slate-700 hover:text-slate-900 transition-colors">
                                Trust & Governance
                            </Link>
                        </li>
                    </ul>
                </div>
            </div>

            <div className="border-t border-slate-200">
                <div className="container-x py-6 flex flex-col md:flex-row justify-between gap-4 text-xs text-slate-500">
                    <div>© {new Date().getFullYear()} NyraAI. All rights reserved.</div>
                    <div className="flex flex-wrap gap-6">
                        <a href="https://cerfgs.com/privacy-policy/" target="_blank" rel="noopener noreferrer" data-testid="footer-privacy-link" className="hover:text-slate-900 transition-colors">Privacy Policy</a>
                        <a href="https://cerfgs.com/terms-and-conditions/" target="_blank" rel="noopener noreferrer" data-testid="footer-terms-link" className="hover:text-slate-900 transition-colors">Terms &amp; Conditions</a>
                    </div>
                </div>
            </div>
        </footer>
    );
};

export default Footer;
